var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.points)?_c('status-map',{attrs:{"points":_vm.points,"start-location":_vm.startLocation}}):_vm._e(),(_vm.notes)?_c('status-box',{attrs:{"notes":_vm.notes}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }